module.exports = __webpack_public_path__ + "invalid-documents.svg?153a7ed9c2f61c28c93c197d099f94da";